import { Controller } from "stimulus";

// Handles MAPD/PDP checkbox selection in chart builder when portal is in split mode.
// Updates the hidden mapd_pdp_selection field and enables/disables the MA payer type hidden field.
export default class extends Controller {
  static targets = ["mapdCheckbox", "pdpCheckbox", "maPayerTypeHidden", "selectionHidden"];

  connect() {
    this.updateSelection();
  }

  updateSelection() {
    const mapdChecked = this.mapdCheckboxTarget.checked;
    const pdpChecked = this.pdpCheckboxTarget.checked;

    // Update the mapd_pdp_selection hidden field
    let selection = null;

    if (mapdChecked && pdpChecked) {
      selection = "both";
    } else if (mapdChecked) {
      selection = "mapd";
    } else if (pdpChecked) {
      selection = "pdp";
    }
    this.selectionHiddenTarget.value = selection || "";

    // Enable/disable the MA payer type hidden field
    // When either MAPD or PDP is checked, we need to include medicare_advantage in payer_type_ids
    this.maPayerTypeHiddenTarget.disabled = !mapdChecked && !pdpChecked;
  }
}
